var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { Textarea } from "@mui/joy";
/** <b>Composant d'affichage en mode édition d'un champ de type text</b>*/
export default function TextFieldEdit(_a) {
    var record = _a.record, fieldName = _a.fieldName, onUpdate = _a.onUpdate, fieldClassName = _a.fieldClassName, fieldMetadata = _a.fieldMetadata, isReport = _a.isReport;
    var defaultValue = useMemo(function () {
        if (!record) {
            return "";
        }
        return isReport
            ? record.value
            : record[fieldName || ""] || (fieldMetadata === null || fieldMetadata === void 0 ? void 0 : fieldMetadata.default);
    }, [record, fieldName]);
    var _b = useState(""), value = _b[0], setValue = _b[1];
    useEffect(function () {
        setValue(defaultValue);
    }, [defaultValue]);
    return (_jsx("div", __assign({ className: "flex w-full text-ellipsis overflow-hidden ".concat(fieldClassName ? fieldClassName : "") }, { children: _jsx(Textarea, { minRows: 5, maxRows: 8, value: value, autoFocus: true, className: "w-full p-2 rounded-lg ", onChange: function (event) {
                var _a;
                var newValue = event.target.value;
                setValue(newValue);
                if (onUpdate) {
                    onUpdate((_a = {}, _a[fieldName || ""] = newValue, _a));
                }
            } }) })));
}
